const LOAD_MACHINE_METRICS_ALERT_HISTORY = 'MACHINES_METRICS/LOAD_ALERT_HISTORY';

export { LOAD_MACHINE_METRICS_ALERT_HISTORY };
